import React from 'react';
import { createIcon } from '@stockx/icons';

const FacebookIcon = createIcon({
  displayName: 'FacebookIcon',
  viewBox: '0 0 44 44',
  path: (
    <g>
      <path d="M44,22C44,9.85,34.15,0,22,0S0,9.85,0,22c0,10.98,8.05,20.08,18.56,21.73v-15.37h-5.59v-6.36h5.59v-4.85c0-5.51,3.28-8.56,8.31-8.56,2.41,0,4.92,.43,4.92,.43v5.41h-2.77c-2.73,0-3.59,1.7-3.59,3.44v4.13h6.1l-.98,6.36h-5.13v15.37c10.52-1.65,18.56-10.75,18.56-21.73Z" />
      <path
        d="M30.56,28.36l.98-6.36h-6.1v-4.13c0-1.74,.85-3.44,3.59-3.44h2.77v-5.41s-2.52-.43-4.92-.43c-5.03,0-8.31,3.05-8.31,8.56v4.85h-5.59v6.36h5.59v15.37c1.12,.18,2.27,.27,3.44,.27s2.32-.09,3.44-.27v-15.37h5.13Z"
        fill="transparent"
      />
    </g>
  ),
});

export default FacebookIcon;
